module.exports = __webpack_public_path__ + "faddaf0481f8df4599c8fdb762352251.pdf";